$(function(){
    $(window)
        .load(showTopButton)
        .scroll(showTopButton);
})


function showTopButton(){
    var win = $(window);
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };

    if(viewport.top>100) $(".anchor-to-top.anchor-hidden").removeClass("anchor-hidden");
    else $(".anchor-to-top:not(.anchor-hidden)").addClass("anchor-hidden");
}